import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import { withSnackbar } from 'notistack';
import BreadCrumbs from "../../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../../components/AppAnimate";
import AppCard from "../../../../components/layouts/components/AppCard";
import CodeEditor from "../../template/components/CodeEditor";
import Accordion from "@material-ui/core/Accordion/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails/AccordionDetails";
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import SubTitle from "../../../../components/elements/SubTitle";
import Alert from "@material-ui/lab/Alert/Alert";
import LiveHelpRoundedIcon from '@material-ui/icons/LiveHelpRounded';
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import Typography from "@material-ui/core/Typography/Typography";

class CustomCode extends React.Component {
    classes = this.props.classes;
    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.custom_code}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.custom_code}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.custom_code}/>
                            }>
                            <Alert style={{marginBottom:30}} severity="info" icon={<LiveHelpRoundedIcon fontSize="inherit" />} >
                                <AlertTitle><strong>{Translate.customCodeTitle}</strong></AlertTitle>
                                {Translate.customCodeText}
                            </Alert>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreRoundedIcon />}
                                >
                                    <SubTitle align="left">{Translate.custom_css}</SubTitle>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2} justify="center" alignItems="center">
                                        <Grid item xs={12}>
                                            <CodeEditor type="custom_css"/>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreRoundedIcon />}
                                >
                                    <SubTitle align="left">{Translate.custom_js}</SubTitle>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2} justify="center" alignItems="center">
                                        <Grid item xs={12}>
                                            <CodeEditor type="custom_js"/>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreRoundedIcon />}
                                >
                                    <SubTitle align="left">{Translate.custom_head}</SubTitle>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2} justify="center" alignItems="center">
                                        <Grid item xs={12}>
                                            <Typography>
                                                {Translate.customHeadDescription}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <CodeEditor type="custom_head"/>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreRoundedIcon />}
                                >
                                    <SubTitle align="left">{Translate.custom_body}</SubTitle>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2} justify="center" alignItems="center">
                                        <Grid item xs={12}>
                                            <Typography>
                                                {Translate.customBodyDescription}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <CodeEditor type="custom_body"/>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
export default withSnackbar(withStyles(Styles)(CustomCode));
